"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const Input_1 = __importDefault(require("../Input"));
const StyledContainer = styled_components_1.default.div `
  width: 241px;
`;
const StyledHelperText = styled_components_1.default.div `
  font-size: 14px;
  font-family: Nimbus Sans Regular;
  color: ${tokens.ColorGrey600};
  width: 100%;
`;
class DateComponent extends react_1.Component {
    render() {
        const { value: { month, day, year }, helperText, errorMessage, onChange, hasError } = this.props;
        return (react_1.default.createElement(StyledContainer, null,
            react_1.default.createElement(Input_1.default, { placeholder: "MM", value: month, width: 60, onChange: onChange, name: "month", hasError: hasError, maxLength: 2 }),
            react_1.default.createElement(Input_1.default, { placeholder: "DD", value: day, width: 60, marginLeftPx: 16, onChange: onChange, name: "day", hasError: hasError, maxLength: 2 }),
            react_1.default.createElement(Input_1.default, { placeholder: "YYYY", value: year, width: 73, marginLeftPx: 16, onChange: onChange, name: "year", hasError: hasError, maxLength: 4 }),
            helperText && !errorMessage && (react_1.default.createElement(StyledHelperText, null, helperText))));
    }
}
exports.default = DateComponent;
//# sourceMappingURL=DateComponent.js.map